import { AppReducerOwnState } from "model/AppReducer";
import { IntegrationsState } from "model/IntegrationsState";
import { LookAndFeelModel } from "model/LookAndFeelModel";
import { Process } from "model/process/Process";
import { AppUserData } from "model/UserData";
import Cookie from "shared/Cookie";

export interface AppReducerState {
    state: AppReducerOwnState;
    dispatch: (payload: AppActions) => void;
}

type ActionMap<M extends { [index: string]: unknown }> = {
    [Key in keyof M]: M[Key] extends undefined
        ? {
              type: Key;
          }
        : {
              type: Key;
              payload: M[Key];
          };
};

export enum Types {
    SET_LOOK_AND_FEEL = "SET_LOOK_AND_FEEL",
    SET_USER_DATA = "SET_USER_DATA",
    SET_INTEGRATIONS = "SET_INTEGRATIONS",
    APPEND_INTEGRATIONS = "APPEND_INTEGRATIONS",
    UPDATE_INTEGRATION = "UPDATE_INTEGRATION",
    SHOW_COOKIE_POLICY = "SHOW_COOKIE_POLICY",
}

export type ActionPayloads = {
    [Types.SET_LOOK_AND_FEEL]: {
        lookAndFeel: LookAndFeelModel;
    };
    [Types.SET_USER_DATA]: {
        userData?: AppUserData;
    };
    [Types.SET_INTEGRATIONS]: {
        integrations: IntegrationsState;
    };
    [Types.APPEND_INTEGRATIONS]: {
        integrations: IntegrationsState;
    };
    [Types.UPDATE_INTEGRATION]: {
        processId: number;
        updatedProcess: Process;
    };
    [Types.SHOW_COOKIE_POLICY]: {
        showCookiePolicy: boolean;
    };
};
export type AppActions =
    ActionMap<ActionPayloads>[keyof ActionMap<ActionPayloads>];

export const initialState: AppReducerOwnState = {
    lookAndFeel: {},
    userData: Cookie.getUserData(),
    integrations: {
        processes: [],
    },
    showCookiePolicy: false
};

export function reducer(
    state: AppReducerOwnState,
    action: AppActions,
): AppReducerOwnState {
    switch (action.type) {
        case Types.SET_LOOK_AND_FEEL:
        case Types.SET_USER_DATA:
        case Types.SET_INTEGRATIONS:
        case Types.SHOW_COOKIE_POLICY: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case Types.APPEND_INTEGRATIONS: {
            return {
                ...state,
                integrations: {
                    processes: [
                        ...state.integrations.processes,
                        ...action.payload.integrations.processes,
                    ],
                },
            };
        }
        case Types.UPDATE_INTEGRATION: {
            const processToUpdateIndex = state.integrations.processes.findIndex(
                (x) => x.processId === action.payload.processId,
            );

            if (processToUpdateIndex === -1) {
                return state;
            }
            const processes = Object.assign(
                [] as Process[],
                state.integrations.processes,
            );
            const processToUpdate = processes[processToUpdateIndex];
            processToUpdate.processId = action.payload.updatedProcess.processId;
            processToUpdate.deploymentId =
                action.payload.updatedProcess.deploymentId;
            processToUpdate.productionDeploymentId =
                action.payload.updatedProcess.productionDeploymentId;
            processToUpdate.templateId =
                action.payload.updatedProcess.templateId;

            const newState = {
                ...state,
                integrations: {
                    processes: processes,
                },
            };
            return newState;
        }
        default:
            return initialState;
    }
}
